// Shared types for TVIA AI
export const languageNames = {
    en: 'English',
    es: 'Español',
    fr: 'Français',
    de: 'Deutsch',
    it: 'Italiano',
    pt: 'Português',
    ru: 'Русский',
    zh: '中文',
    ja: '日本語',
    ko: '한국어',
    ar: 'العربية',
    he: 'עברית'
};
export const languageFlags = {
    en: '🇺🇸',
    es: '🇪🇸',
    fr: '🇫🇷',
    de: '🇩🇪',
    it: '🇮🇹',
    pt: '🇵🇹',
    ru: '🇷🇺',
    zh: '🇨🇳',
    ja: '🇯🇵',
    ko: '🇰🇷',
    ar: '🇦🇪',
    he: '🇮🇱'
};
export const isRTL = (language) => {
    return ['ar', 'he'].includes(language);
};
export const legalSystems = {
    US: {
        name: 'United States Federal Court System',
        language: 'en',
        currency: 'USD',
        filingFee: 40000, // $400 in cents
        documentFormat: 'Federal Rules of Civil Procedure',
        requiredFields: ['Case Caption', 'Jurisdiction', 'Statement of Facts', 'Claims for Relief', 'Prayer for Relief']
    },
    UK: {
        name: 'United Kingdom High Court',
        language: 'en',
        currency: 'GBP',
        filingFee: 30800, // £308 in pence
        documentFormat: 'Civil Procedure Rules',
        requiredFields: ['Claim Form', 'Particulars of Claim', 'Statement of Truth']
    },
    IL: {
        name: 'Israeli Civil Court System',
        language: 'he',
        currency: 'ILS',
        filingFee: 150000, // ₪1500 in agorot
        documentFormat: 'חוקי סדר הדין האזרחי',
        requiredFields: ['כתב תביעה', 'עילת התביעה', 'הסעד המבוקש', 'שווי התביעה']
    },
    AE: {
        name: 'UAE Civil Court System',
        language: 'ar',
        currency: 'AED',
        filingFee: 100000, // 1000 AED in fils
        documentFormat: 'UAE Civil Procedure Law',
        requiredFields: ['Statement of Claim', 'Facts', 'Legal Basis', 'Relief Sought']
    },
    DE: {
        name: 'German Civil Court System',
        language: 'de',
        currency: 'EUR',
        filingFee: 35000, // €350 in cents
        documentFormat: 'Zivilprozessordnung (ZPO)',
        requiredFields: ['Klageschrift', 'Sachverhalt', 'Anträge']
    },
    FR: {
        name: 'French Civil Court System',
        language: 'fr',
        currency: 'EUR',
        filingFee: 32000, // €320 in cents
        documentFormat: 'Code de procédure civile',
        requiredFields: ['Assignation', 'Exposé des faits', 'Moyens en droit', 'Prétentions']
    }
};
